import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Page, TrustBanner } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ProgrammeAffiliationPage.module.css';

const ProgrammeAffiliationPage = () => {
  const intl = useIntl();

  const profileItems = [
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.profile1' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.profile2' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.profile3' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.profile4' }),
  ];

  const supportItems = [
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.support1' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.support2' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.support3' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.support4' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.support5' }),
  ];

  const audienceBenefits = [
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.audienceBenefit1' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.audienceBenefit2' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.audienceBenefit3' }),
    intl.formatMessage({ id: 'ProgrammeAffiliationPage.audienceBenefit4' }),
  ];

  return (
    <Page
      title={intl.formatMessage({ id: 'ProgrammeAffiliationPage.title' })}
      description={intl.formatMessage({ id: 'ProgrammeAffiliationPage.metaDescription' })}
      scrollingDisabled={false}
    >
      <TopbarContainer />

      <main className={css.root}>
        <section className={css.hero}>
          <div className={css.heroContent}>
            <span className={css.heroBadge}>
              <FormattedMessage id="ProgrammeAffiliationPage.heroBadge" />
            </span>
            <h1 className={css.heroTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.heroTitle" />
            </h1>
            <p className={css.heroSubtitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.heroSubtitle" />
            </p>
            <a
              className={css.ctaPrimary}
              href="https://ui.awin.com/express-signup/fr/awin/126415/59858656-20f3-4337-bc99-f611b25163f3?t=jedgFQLjZ29QH20B1keGv7vFFP-MRPA7--zTNk_jj0E"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage id="ProgrammeAffiliationPage.ctaPrimary" />
            </a>
          </div>
        </section>

        <section className={css.section}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.aboutTitle" />
            </h2>
            <p className={css.sectionText}>
              <FormattedMessage id="ProgrammeAffiliationPage.aboutText" />
            </p>
          </div>
        </section>

        <section className={`${css.section} ${css.altSection}`}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.whyJoinTitle" />
            </h2>
            <p className={css.sectionText}>
              <FormattedMessage id="ProgrammeAffiliationPage.whyJoinText" />
            </p>
          </div>
        </section>

        <section className={css.section}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.commissionTitle" />
            </h2>
            <div className={css.metricsGrid}>
              <article className={css.metricCard}>
                <p className={css.metricValue}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionValue1" />
                </p>
                <p className={css.metricLabel}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionLabel1" />
                </p>
              </article>
              <article className={css.metricCard}>
                <p className={css.metricValue}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionValue2" />
                </p>
                <p className={css.metricLabel}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionLabel2" />
                </p>
              </article>
              <article className={css.metricCard}>
                <p className={css.metricValue}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionValue3" />
                </p>
                <p className={css.metricLabel}>
                  <FormattedMessage id="ProgrammeAffiliationPage.commissionLabel3" />
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className={`${css.section} ${css.altSection}`}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.supportTitle" />
            </h2>
            <ul className={css.list}>
              {supportItems.map(item => (
                <li key={item} className={css.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className={css.section}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.profilesTitle" />
            </h2>
            <ul className={css.list}>
              {profileItems.map(item => (
                <li key={item} className={css.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className={`${css.section} ${css.altSection}`}>
          <div className={css.container}>
            <h2 className={css.sectionTitle}>
              <FormattedMessage id="ProgrammeAffiliationPage.audienceTitle" />
            </h2>
            <ul className={css.list}>
              {audienceBenefits.map(item => (
                <li key={item} className={css.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className={css.ctaSection}>
          <h2 className={css.ctaTitle}>
            <FormattedMessage id="ProgrammeAffiliationPage.finalCtaTitle" />
          </h2>
          <p className={css.ctaText}>
            <FormattedMessage id="ProgrammeAffiliationPage.finalCtaText" />
          </p>
          <a
            className={css.ctaPrimary}
            href="https://ui.awin.com/express-signup/fr/awin/126415/59858656-20f3-4337-bc99-f611b25163f3?t=jedgFQLjZ29QH20B1keGv7vFFP-MRPA7--zTNk_jj0E"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="ProgrammeAffiliationPage.ctaPrimary" />
          </a>
        </section>

        <TrustBanner />
      </main>

      <FooterContainer />
    </Page>
  );
};

export default ProgrammeAffiliationPage;
